import React, { Component, PureComponent } from "react";


export default class EventTypesLegends extends React.Component {

    constructor(props){
        super(props);
        this.isSelected = this.isSelected.bind(this);
        this.selectionChanged = this.selectionChanged.bind(this);
    }

    isSelected(eventTypeId){
        return this.props.selectedEventTypeIds.indexOf(eventTypeId) !== -1;
    }

    selectionChanged(event) {
        this.props.selectionChanged(event.target.value, event.target.checked);
    }

    render(){
        return <table style={{backgroundColor:'#FAFAFA',position:'fixed',bottom:'10px',left:'10px',borderWidth:'1px',borderStyle:'solid',borderColor:'grey'}} cellPadding="5">
        <tbody>
            {this.props.eventTypes.map(eventType => (
              <tr key={eventType.eventTypeId}> 
              <td><input type="checkbox" value={eventType.eventTypeId} checked={this.isSelected(eventType.eventTypeId)} onChange={this.selectionChanged} /></td>
              <td><div style={{width:'20px',height:'20px',backgroundColor:eventType.colour}}>&nbsp;</div> </td><td>{eventType.typeName} ({eventType.count}) </td>
              </tr>
            ))}
            </tbody>
            </table>
        }
    }


// WEBPACK FOOTER //
// ./src/EventTypesLegends.js